import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
    },
    deleteButton: {
      height: 32,
      position: 'absolute',
      right: 0,
      top: -24,
      width: 32,
      zIndex: 1,
    },
    field: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      color: colours.neutral[900],
      fontSize: 14,
      fontWeight: 500,
      marginBottom: spacing(2),
    },
    row: {
      columnGap: spacing(4),
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      rowGap: spacing(4),
    },
    durationFields: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: spacing(2),
    },
    textField: {
      '& .MuiInputBase-root': {
        height: 'auto',
        minHeight: 40,
      },
    },
  });
